module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\nvar i18n = require(\'@cdo/netsim/locale\');\n%>\n<%\n/**\n * This block destructures the local variables for use within this ejs template.\n */\nvar myHostname = locals.myHostname;\nvar myAddress = locals.myAddress;\nvar shareLink = locals.shareLink;\n%>\n<div class="content-wrap">\n  <% if (myHostname) { %>\n  <p>My hostname: <%= myHostname %></p>\n  <% } %>\n\n  <% if (myAddress) { %>\n  <p>My address: <%= myAddress %></p>\n  <% } %>\n\n  <% if (shareLink) { %>\n  <p><a href="<%= shareLink %>"><%= i18n.shareThisNetwork() %></a></p>\n  <% } %>\n</div>\n', __filename = "src/netsim/NetSimStatusPanel.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var i18n = require("@cdo/netsim/locale");
        __line = 3;
        __append("\n");
        __line = 4;
        var myHostname = locals.myHostname;
        var myAddress = locals.myAddress;
        var shareLink = locals.shareLink;
        __line = 11;
        __append('\n<div class="content-wrap">\n  ');
        __line = 13;
        if (myHostname) {
            __append("\n  <p>My hostname: ");
            __line = 14;
            __append(escapeFn(myHostname));
            __append("</p>\n  ");
            __line = 15;
        }
        __append("\n\n  ");
        __line = 17;
        if (myAddress) {
            __append("\n  <p>My address: ");
            __line = 18;
            __append(escapeFn(myAddress));
            __append("</p>\n  ");
            __line = 19;
        }
        __append("\n\n  ");
        __line = 21;
        if (shareLink) {
            __append('\n  <p><a href="');
            __line = 22;
            __append(escapeFn(shareLink));
            __append('">');
            __append(escapeFn(i18n.shareThisNetwork()));
            __append("</a></p>\n  ");
            __line = 23;
        }
        __append("\n</div>\n");
        __line = 25;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}